export class BillGenerationModel{
    contractor:string
    firstFortnightDeheading:FirstFortNightDeheading[]
    finalFortnightDeheading:FinalFortNightDeheading[]
    firstlFortnightPeeling:FirstFortnightPeeling[]
    finallFortnightPeeling:FinalFortnightPeeling[]
    firstPeelingCutting: FirstPeelingCuttingModel[]
    finalPeelingCutting: FinalPeelingCuttingModel[]
    other:OtherModel[]



   
    
    constructor(
        contractor:string,
        firstFortnightDeheading:FirstFortNightDeheading[],
        finalFortnightDeheading:FinalFortNightDeheading[],
        firstlFortnightPeeling:FirstFortnightPeeling[],
         finallFortnightPeeling:FinalFortnightPeeling[],
        firstPeelingCutting: FirstPeelingCuttingModel[],
       finalPeelingCutting: FinalPeelingCuttingModel[],
        other:OtherModel[]




     
    ){
        this.contractor=contractor
        this.firstFortnightDeheading=firstFortnightDeheading
        this.finalFortnightDeheading=finalFortnightDeheading
        this.firstlFortnightPeeling = firstlFortnightPeeling
        this.finallFortnightPeeling = finallFortnightPeeling
        this.firstPeelingCutting = firstPeelingCutting
        this.finalPeelingCutting = finalPeelingCutting
        this.other = other
       
    }
}

export class FirstFortNightDeheading{
    count:string
    rate:string
    amount:string
    quantity:string
    constructor(
        count:string,
        rate:string,
       amount:string,
       quantity:string
    )
    {
        this.count = count
        this.rate = rate
        this.amount = amount
        this.quantity = quantity

    }
}

export class FinalFortNightDeheading{
    count:string
    rate:string
    amount:string
    quantity:string
    constructor(
        count:string,
        rate:string,
       amount:string,
       quantity:string
    )
    {
        this.count = count
        this.rate = rate
        this.amount = amount
        this.quantity = quantity

    }
}

export class FirstFortnightPeeling{
    scope:string
    scopeData:ScopeData[]
    constructor(
        scope:string,
        scopeData:ScopeData[]
    )
    {
        this.scopeData = scopeData
        this.scope = scope
    }
}
export class ScopeData {
    count:string
    rate:string
    amount:string
    quantity:string
    scopeOfWork: string

    constructor(
        count:string,
        rate:string,
       amount:string,
       quantity:string,
       scopeOfWork: string

    )
    {
        this.count = count
        this.rate = rate
        this.amount = amount
        this.quantity = quantity,
        this.scopeOfWork = scopeOfWork


    }
}

export class FinalFortnightPeeling{
    scope:string
    scopeData:LastScopeData[]
    constructor(
        scope:string,
        scopeData:LastScopeData[]
    )
    {
        this.scopeData = scopeData
        this.scope = scope
    }
}
export class LastScopeData {
    count:string
    rate:string
    amount:string
    quantity:string
    scopeOfWork: string

    constructor(
        count:string,
        rate:string,
       amount:string,
       quantity:string,
       scopeOfWork: string

    )
    {
        this.count = count
        this.rate = rate
        this.amount = amount
        this.quantity = quantity,
        this.scopeOfWork = scopeOfWork


    }

    
}

export class FirstPeelingCuttingModel {
    count:string
    rate:string
    amount:string
    quantity:string
    scopeOfWork: string

    constructor(
        count:string,
        rate:string,
       amount:string,
       quantity:string,
       scopeOfWork: string

    )
    {
        this.count = count
        this.rate = rate
        this.amount = amount
        this.quantity = quantity,
        this.scopeOfWork = scopeOfWork


    }
}

export class FinalPeelingCuttingModel {
    count:string
    rate:string
    amount:string
    quantity:string
    scopeOfWork: string

    constructor(
        count:string,
        rate:string,
       amount:string,
       quantity:string,
       scopeOfWork: string

    )
    {
        this.count = count
        this.rate = rate
        this.amount = amount
        this.quantity = quantity,
        this.scopeOfWork = scopeOfWork
    }


}

export class FirstOther {
   
    amount:string
    quantity:string
    autoBusQuantity?: string

    constructor(

       amount:string,
       quantity:string,
       autoBusQuantity?: string
    )
    {
     
        this.amount = amount
        this.quantity = quantity
        this.autoBusQuantity = autoBusQuantity
    }

}


export class FinalOther {
   
    amount:string
    quantity:string
    autoBusQuantity?: string


    constructor(

       amount:string,
       quantity:string,
       autoBusQuantity?: string

    )
    {
     
        this.amount = amount
        this.quantity = quantity
        this.autoBusQuantity = autoBusQuantity

    }

}


export class OtherModel {
   
    firstForntOther:FirstOther
    secondForntOther:FinalOther

    constructor(

        firstForntOther:FirstOther,
        secondForntOther:FinalOther
    )
    {
     
        this.firstForntOther = firstForntOther
        this.secondForntOther = secondForntOther
    }

}
